/** True for a request that gave up waiting (axios says either, by version and config). */
export const isTimeout = (error) => error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT";

/**
 * The API's own words from a response body, or "" — `error` is sometimes an
 * object (`{ message }`), and an object handed to toast() crashes the render.
 */
export const apiBodyMessage = (data) => {
  const pick = (v) => (typeof v === "string" && v.trim() ? v : typeof v?.message === "string" && v.message.trim() ? v.message : "");
  return pick(data?.message) || pick(data?.error);
};

/**
 * The message to show for a failed request: the API's own words when it sent
 * any, a plain "no answer" for a timeout or a dropped connection, else the
 * caller's fallback. One place, so every toast on a page says the same thing
 * for the same failure.
 */
export const apiErrorMessage = (error, fallback = "Something went wrong. Please try again.") => {
  if (isTimeout(error)) return "No answer from the server. Please try again.";
  const data = error?.response?.data;
  // A 401 says sign in again. Its body is often just "Authorization
  // Required", which tells an admin nothing; the newer ones carry a readable
  // `message`, used when present.
  if (error?.response?.status === 401) {
    return typeof data?.message === "string" && data.message.trim() ? data.message : "Your session has expired. Please log in again.";
  }
  const fromApi = apiBodyMessage(data);
  if (fromApi) return fromApi;
  if (error && !error.response && error.request) return "Can't reach the server. Check your connection and try again.";
  return fallback;
};
